var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGallary1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 6,
    fill: "url(#paint0_linear_142_1690)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_142_1690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8503 9.2627H11.3503C11.1753 9.2627 10.9878 9.2752 10.8253 9.3002C9.98778 9.4377 9.35028 10.1502 9.35028 10.9877C9.35028 14.9502 9.33778 18.9002 9.35028 22.8627C9.35028 23.8627 10.2128 24.7377 11.2128 24.7377H22.9503C23.3003 24.7377 23.6128 24.6252 23.8878 24.4252C24.4128 24.0252 24.6378 23.4752 24.6378 22.8377C24.6503 20.8752 24.6503 18.9002 24.6503 16.9252V11.0502C24.6503 9.9377 23.9628 9.2627 22.8503 9.2627ZM13.9128 11.5752C15.0253 11.5627 15.9253 12.4627 15.9253 13.5877C15.9253 14.7002 15.0378 15.6002 13.9253 15.6002C12.8128 15.6002 11.9128 14.6877 11.9128 13.5877C11.9128 12.4877 12.8128 11.5752 13.9128 11.5752ZM22.8128 22.1502C22.7753 22.2127 22.6628 22.2502 22.5128 22.2627C22.5003 22.2752 22.4753 22.2752 22.4503 22.2752H14.7378C14.1628 22.2752 13.5753 22.2627 13.0003 22.2627C12.7378 22.2627 12.4628 22.2502 12.2003 22.2502C11.9503 22.2502 11.7128 22.3002 11.4503 22.2752C11.4378 22.2752 11.4378 22.2752 11.4128 22.2627C11.4003 22.2627 11.3753 22.2502 11.3503 22.2377C11.1878 22.1377 11.5253 21.8877 11.5753 21.8127C11.7503 21.5877 13.7003 18.8627 13.7253 18.8252C13.9878 18.4377 14.3503 18.2127 14.7253 18.2127C15.2753 18.2127 15.5628 18.8002 15.9878 19.0502C16.5628 19.3877 16.9378 18.9377 17.2128 18.4877C17.4003 18.1877 17.6003 17.8877 17.7878 17.5752C17.9003 17.4002 18.0128 17.2127 18.1253 17.0252C18.2628 16.8127 18.4003 16.6002 18.5378 16.3752L18.8128 15.9377C18.8378 15.9002 18.8503 15.8752 18.8753 15.8502C18.9753 15.7002 19.1003 15.6127 19.1878 15.6127C19.2753 15.6127 19.3753 15.7002 19.4628 15.8627C20.4128 17.5627 21.3753 19.2877 22.3128 20.9627L22.7628 21.7752C22.8003 21.8377 22.8253 21.9002 22.8378 21.9502C22.8503 22.0127 22.8503 22.1002 22.8128 22.1502Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_142_1690",
    x1: 25.5,
    y1: 2.27757,
    x2: 8.5,
    y2: 31.7224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C50A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E95E2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_142_1690"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallary1);
export default __webpack_public_path__ + "static/media/gallary1.84aa21fc4d97068501725eb1d9564b01.svg";
export { ForwardRef as ReactComponent };